module.exports = __webpack_public_path__ + "img/enplus.2b34a7a.png";